import Button, { ButtonTypes } from "../../../common/components/button/button";
import TextField from "../../../common/components/inputFields/textFields/textField";
import { ReactComponent as Logo } from "../../../assets/logo.svg";
import "./loginPage.scss";
import { useNavigate } from "react-router-dom";
import { loginModel } from "../models/loginModel";
import { useState } from "react";
import { UserApi } from "../../../common/services/api/userApi";
import { loadUserData } from "../../../common/reducers/userReduer";
import { useAppDispatch } from "../../../store";
import { useLoadHandler } from "../../../common/customHooks/useLoadHandler";

export default function LoginPage() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loginData, setLoginData] = useState<loginModel>({} as loginModel);

  const { loadingStatus, callFetchAsync } = useLoadHandler(async () => {
    let result = await UserApi().login(loginData);
    localStorage.setItem(
      "techsauce-campaign-user-data",
      JSON.stringify(result)
    );
    dispatch(loadUserData(result));
    navigate("/home");
  });

  return (
    <div className="login-page">
      <div className="login-form-section">
        <Logo height={100} width={100} style={{ alignSelf: "center" }} />
        <h2 className="login-title">Sign In</h2>
        <TextField
          autoComplete="Username"
          title="Username"
          onChange={(e) => {
            setLoginData({ ...loginData, usernameEmail: e });
          }}
        />
        <TextField
          autoComplete="Password"
          title="Password"
          isSecure
          onChange={(e) => {
            setLoginData({ ...loginData, password: e });
          }}
        />
        <Button
          type={ButtonTypes.PRIMARY}
          text={"Login"}
          loadingStatus={loadingStatus}
          onClick={callFetchAsync}
        />
      </div>
    </div>
  );
}
